import { render, staticRenderFns } from "./AddOrEditCourse.vue?vue&type=template&id=c774936c&scoped=true"
import script from "./AddOrEditCourse.vue?vue&type=script&lang=js"
export * from "./AddOrEditCourse.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditCourse.vue?vue&type=style&index=0&id=c774936c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c774936c",
  null
  
)

export default component.exports